import def from './default.wav';
import caps from './caps.wav';
import backspace from './backspace.wav';
import enter from './enter.wav';
import lang from './lang.wav';
import shift from './shift.wav';
import sounds from './sounds.wav';
import space from './space.wav';

export const en = {
  def,
  caps,
  backspace,
  enter,
  lang,
  shift,
  sounds,
  space,
};
